<ng-container *ngIf="structure['hide_frontend'] != 1">
    <ng-container *ngIf="structure['id_function']">
        <app-generic style="cursor: pointer;" (click)="onClickEvent($event); $event.stopPropagation()" [structure]="structure"></app-generic>
    </ng-container>
    <ng-container *ngIf="!structure['id_function']">
        <app-generic [structure]="structure"></app-generic>
    </ng-container>
</ng-container>
